"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRfiTexts = void 0;
var useRfiTexts_hook_1 = require("./useRfiTexts.hook");
Object.defineProperty(exports, "useRfiTexts", { enumerable: true, get: function () { return useRfiTexts_hook_1.useRfiTexts; } });
//# sourceMappingURL=index.js.map